import * as documentsActions from './documentsActions';
import documentsReducer from './documentsReducer';
import documentsSagas from './documentsSagas';
import * as documentsSelectors from './documentsSelectors';
import * as documentsTransformers from './documentsTransformers';
import * as documentsTypes from './documentsTypes';

const { DOCUMENTS_REDUCER_KEY } = documentsTypes;

export {
  DOCUMENTS_REDUCER_KEY,
  documentsTypes,
  documentsActions,
  documentsTransformers,
  documentsSagas,
  documentsReducer,
  documentsSelectors,
};
